export default "__VITE_ASSET__D$h6xAvY__"